import React, { useEffect, useState } from "react";
import { 
  Box, Card, CardContent, CardMedia, Typography, Grid, CircularProgress,  
} from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from '../../firebase';
import { useNavigate } from "react-router-dom";
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';

const EventListRelated = () => {
  const [events, setEvents] = useState([]);
  const [landingEvents, setLandingEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, ] = useState({
    privacy: [],
    eventType: [],
    price: [],
  });
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "events"));
        const eventList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setEvents(eventList);
        setLandingEvents(eventList); // Initialize with all events
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchEvents();
  }, []);

  // Update filters dynamically
  useEffect(() => {
    let filtered = events.filter(event => {
      const matchesPrivacy = 
        filters.privacy.length === 0 || filters.privacy.includes(event.privacy);
      
      const matchesType = 
        filters.eventType.length === 0 || filters.eventType.includes(event.type);
      
      const matchesPrice = 
        filters.price.length === 0 || filters.price.includes(event.price);

      return matchesPrivacy && matchesType && matchesPrice;
    });
    setLandingEvents(filtered);
  }, [filters, events]);

  // Handle filter changes

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />        
      </Box>      
    );
  }

  return (
    <Box sx={{p: 3, maxWidth: "1200px", margin: "auto", textAlign: "center", }}>          
      {/* Event List Section */}
       <Typography variant="h4"
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    p:2,
                  }}
                >
                  Featured events...
                </Typography>
      <Grid container spacing={2} >
                {landingEvents.map(event => (
                  <Grid item key={event.id}  size={{ xs: 12, sm: 4, md: 3 }} >                    
                    <Card 
                      variand="default" 
                      sx={{ maxWidth: 345, padding:0,}}                      
                      onClick={() => navigate(`/explore/${event.eventCode}`)} style={{border:"none",backgroundColor: "transparent"}}
                      >
                      <CardMedia
                        sx={{ width: { xs: "100%", sm: "100%" }, height: 180,  borderRadius: 1,   bgcolor:"grey.100"}}
                        image={event.eventImageURL } // Default image
                        alt={event.eventName}
                        title={event.eventName} 
                      />
                      <CardContent border={0}>                      
                        <Stack direction="row" sx={{ gap: 1, alignItems: 'left', flexGrow: 1, p: 1 }} border={0}>
                            <Avatar
                              sizes="small"
                              alt={event.eventName}
                              src={event.eventImageURL}
                              sx={{ width: 24, height: 24 }}
                            />
                            <Typography noWrap component="p" variant="body2">{event.eventName}</Typography>
                        </Stack>
                      </CardContent>                                
                    </Card>                    
                  </Grid>
                ))}
              </Grid>   
    </Box>
  );
};

export default EventListRelated;
